"use client"

import { A } from "src/components/unstyled/A"
import { routes } from "src/config/routes"
import { localizeText } from "src/localization/utils"

export const ManufacturerInfo = () => {
  const T = localizeText(text)

  return (
    <div>
      <h3 className="text-default text-base">{T.manufacturer}:</h3>
      Flowers & Me GmbH
      <br />
      Robert-Bosch-Str. 8<br />
      78549 Spaichingen
      <br />
      {T.country}
      <br />
      <br />
      <h3 className="text-default text-base">{T.contact}:</h3>
      <A href={routes.contact}>{T.contactOptions} →</A>
    </div>
  )
}

const de = {
  manufacturer: "Hersteller",
  country: "Deutschland",
  contact: "Kontakt",
  contactOptions: "Kontaktmöglichkeiten",
}

const en: typeof de = {
  manufacturer: "Manufacturer",
  country: "Germany",
  contact: "Contact",
  contactOptions: "Contact options",
}

const text = { de, en }
